import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['checkbox', 'match']

  connect() {
    this.change();
  }

  change() {
    // If nested inside a hidden ancestor (e.g. select-toggle match), don't enable inputs — they'd submit alongside the visible field with the same name.
    const insideHidden = this.element.parentElement &&
                         this.element.parentElement.closest('.hidden') !== null;

    this.matchTargets.forEach((target) => {
      if (target.dataset.value == $(this.checkboxTarget).is(":checked").toString()) {
        target.classList.remove('hidden');
        if (!insideHidden) {
          target.querySelectorAll('input,select,textarea').forEach((input) => {
            input.removeAttribute('disabled');
          });
        }
      } else {
        target.classList.add('hidden');
        target.querySelectorAll('input,select,textarea').forEach((input) => {
          input.setAttribute('disabled', 'disabled');
        });
      }
    });
  }
}
